<div class="wrapper flex flex-col justify-between">
  <div class="heading flex flex-row items-center justify-between mb-[40px]">
    <div class="text-type-2">
      {{
      data?.id || data?.uuid
      ? data?.first_name && data?.last_name
      ? data?.first_name + ' ' + data?.last_name
      : data?.name || 'Edit user'
      : 'Add user'
      }}
    </div>
  </div>
  <div class="details flex-1">
    @if (!(data?.id || data?.uuid) && !isAddNewMode && !selectedUserData) {
      <app-dropdown
        (checkForErrors)="checkForErrors($event)"
        [enableSearch]="true"
        [enableAddNew]="true"
        [error]="errorMessages['selectedUser']"
        [options]="userOptions"
        [parentFormGroup]="form"
        [placeholder]="'Select'"
        class="w-full mb-[20px]"
        controlName="selectedUser"
        label="select or add user"
        />
    }
    @if (selectedUserData) {
      <app-view-field class="w-full mb-[20px]" [value]="form?.controls?.firstName?.value" label="first name" />
      <app-view-field class="w-full mb-[20px]" [value]="form?.controls?.lastName?.value" label="last name" />
      <app-view-field class="w-full mb-[20px]" [value]="form?.controls?.email?.value" label="email" />
      <app-view-field class="w-full mb-[20px]" [value]="form?.controls?.phone?.value" label="phone" />
    }

    @if (isAddNewMode || (!selectedUserData && (data?.id || data?.uuid))) {
      <app-text-input
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['firstName']"
        [parentFormGroup]="form"
        class="w-full mb-[20px]"
        controlName="firstName"
        label="first name"
        />
      <app-text-input
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['lastName']"
        [parentFormGroup]="form"
        class="w-full mb-[20px]"
        controlName="lastName"
        label="last name"
        />
      <app-text-input
        (checkForErrors)="checkForErrors($event)"
        (fieldBlur)="onEmailBlur()"
        [error]="errorMessages['email']"
        [parentFormGroup]="form"
        class="w-full mb-[20px]"
        controlName="email"
        label="email"
        />
      <app-text-input
        (checkForErrors)="checkForErrors($event)"
        (fieldBlur)="onPhoneBlur()"
        [error]="errorMessages['phone']"
        [parentFormGroup]="form"
        class="w-full mb-[20px]"
        controlName="phone"
        label="phone"
        phoneNumber
        />
    }
    @if (isAddNewMode || selectedUserData || (data?.id || data?.uuid)) {
      <app-dropdown
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['role']"
        [options]="rolesOptions"
        [parentFormGroup]="form"
        [placeholder]="'Select'"
        class="w-full mb-[20px]"
        controlName="role"
        label="role"
        />
    }
    @if (isDwrReportingHierarchyEnabled && (isAddNewMode || selectedUserData || (data?.id || data?.uuid))) {
      <app-dropdown
        (checkForErrors)="checkForErrors($event)"
        [enableClearSelection]="true"
        [enableSearch]="true"
        [error]="errorMessages['reportsTo']"
        [options]="reportsToOptions"
        [parentFormGroup]="form"
        [placeholder]="'Select'"
        class="w-full mb-[20px]"
        controlName="reportsTo"
        label="reports to"
        />
    }
    @if (form.controls['sites'] && (isAddNewMode || selectedUserData || (data?.id || data?.uuid))) {
      <app-multi-select-dropdown
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['sites']"
        [options]="sitesOptions"
        [parentFormGroup]="form"
        [enableSelectAll]="true"
        [enableSearch]="true"
        [showCount]="true"
        singularText="site"
        pluralText="sites"
        allSelectedText="All sites"
        [enableClearSelection]="true"
        class="w-full mb-[20px]"
        controlName="sites"
        label="sites"
        placeholder="Select"
        />
    }
  </div>
  <div class="action-section w-full flex justify-between items-center gap-[10px] mt-[40px]">
    <app-primary-button (handleClick)="submit()" [isDisabled]="isReadOnly || !isFormDirty" class="w-full">
      Submit
    </app-primary-button>
  </div>
</div>
